export default "__VITE_ASSET__CKXj59Uf__"